(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hl-category-bar"] && !Shopify.designMode) return;
  try {
    
  /* Barra de categorías: arrastre con el ratón, flechas del teclado y encendido
     de los degradados de los extremos.

     Por qué va en el bloque javascript de la sección y no en un archivo de
     assets/: esta sección vive dentro de header-group.json, o sea que está en
     TODAS las páginas, que es justo el caso para el que sirve el paquete de
     sección (un solo archivo, con defer, cacheado aparte). Cero dependencias
     externas.

     Degradación: si este guion no llega a correr, la barra sigue siendo de una
     sola fila y se desplaza con el dedo, con la rueda horizontal y con Tab; lo
     único que se pierde es el arrastre con ratón y el ajuste fino de los
     degradados (el derecho se queda encendido, que es el estado de arranque). */
  (function () {
    var DRAG_MIN = 4; // px antes de considerar que es arrastre y no clic

    function init(nav) {
      if (!nav || nav.dataset.hlCatbarReady === '1') return;
      var list = nav.querySelector('.hl-catbar__list');
      if (!list) return;
      nav.dataset.hlCatbarReady = '1';

      var ticking = 0;
      function paint() {
        ticking = 0;
        var max = list.scrollWidth - list.clientWidth;
        var overflows = max > 1;
        var left = list.scrollLeft;
        nav.dataset.hlOverflow = overflows ? 'true' : 'false';
        nav.dataset.hlStart = !overflows || left <= 1 ? 'true' : 'false';
        nav.dataset.hlEnd = !overflows || left >= max - 1 ? 'true' : 'false';
      }
      function schedule() {
        if (!ticking) ticking = window.requestAnimationFrame(paint);
      }

      list.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if (window.ResizeObserver) new window.ResizeObserver(schedule).observe(list);
      paint();

      /* ---- arrastre con el ratón ----
         Sólo puntero de ratón: en táctil y lápiz el desplazamiento nativo ya es
         mejor que cualquier imitación, y capturar el puntero ahí rompería el
         gesto del sistema. */
      var pid = null;
      var moved = false;
      var startX = 0;
      var startLeft = 0;

      list.addEventListener('pointerdown', function (ev) {
        if (ev.pointerType !== 'mouse' || ev.button !== 0) return;
        pid = ev.pointerId;
        moved = false;
        startX = ev.clientX;
        startLeft = list.scrollLeft;
      });

      list.addEventListener('pointermove', function (ev) {
        if (pid === null || ev.pointerId !== pid) return;
        var dx = ev.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) < DRAG_MIN) return;
          moved = true;
          list.classList.add('hl-catbar__list--dragging');
          try {
            list.setPointerCapture(pid);
          } catch (err) {
            /* sin captura el arrastre sigue funcionando dentro del elemento */
          }
        }
        ev.preventDefault();
        list.scrollLeft = startLeft - dx;
      });

      function endDrag(ev) {
        if (pid === null || (ev && ev.pointerId !== pid)) return;
        try {
          list.releasePointerCapture(pid);
        } catch (err) {
          /* ya liberado */
        }
        pid = null;
        list.classList.remove('hl-catbar__list--dragging');
      }
      list.addEventListener('pointerup', endDrag);
      list.addEventListener('pointercancel', endDrag);

      /* Arrastrar NO debe abrir la categoría sobre la que se soltó el botón.
         En fase de captura para llegar antes que el enlace.
         detail > 0 = clic hecho con un puntero. Un clic disparado con Enter o
         Espacio sobre un chip trae detail 0, y ése JAMÁS se cancela: si el
         arrastre anterior terminó fuera de la lista, "moved" puede haber
         quedado encendido, y sin esta comprobación el teclado se comería un
         enlace. */
      list.addEventListener(
        'click',
        function (ev) {
          if (!moved || ev.detail === 0) return;
          moved = false;
          ev.preventDefault();
          ev.stopPropagation();
        },
        true
      );

      /* El navegador intenta arrastrar el enlace (y su imagen) como si fuera un
         objeto; eso cancelaría el desplazamiento a media maniobra. */
      list.addEventListener('dragstart', function (ev) {
        if (pid !== null) ev.preventDefault();
      });

      /* ---- teclado ----
         Sólo cuando el foco está en el contenedor mismo: si está en un chip, las
         flechas deben seguir haciendo lo que hace el navegador. */
      list.addEventListener('keydown', function (ev) {
        if (ev.target !== list) return;
        var max = list.scrollWidth - list.clientWidth;
        if (max <= 1) return;
        var step = Math.max(120, Math.round(list.clientWidth * 0.6));
        var to = null;
        if (ev.key === 'ArrowRight') to = list.scrollLeft + step;
        else if (ev.key === 'ArrowLeft') to = list.scrollLeft - step;
        else if (ev.key === 'Home') to = 0;
        else if (ev.key === 'End') to = max;
        if (to === null) return;
        ev.preventDefault();
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollTo({ left: to, behavior: smooth ? 'smooth' : 'auto' });
      });
    }

    function initAll(root) {
      var nodes = (root || document).querySelectorAll('[data-hl-catbar]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    /* El editor de temas vuelve a pintar la sección al cambiar un ajuste: el
       nodo anterior se tira y con él los escuchadores. */
    document.addEventListener('shopify:section:load', function (ev) {
      initAll(ev.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
